const headerHeight = {
  bigscreen: 272,
  desktop: 272,
  tablet: 160,
  smartphone: 105,
};
const headerHeightFixed = {
  bigscreen: 160,
  desktop: 160,
  tablet: 160,
  smartphone: 105,
};

export { headerHeight, headerHeightFixed };
